"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CompetitorProductBindDTO_1 = require("../../model/dto/CompetitorProductBindDTO");

var CompetitorProductBindDTOConverter_1 = require("./CompetitorProductBindDTOConverter");
/**
 * Implementation of CompetitorProductBindDTOConverter
 *
 * @author RV
 */


var CompetitorProductBindDTOConverterImpl =
/*#__PURE__*/
function (_CompetitorProductBin) {
  _inherits(CompetitorProductBindDTOConverterImpl, _CompetitorProductBin);

  function CompetitorProductBindDTOConverterImpl() {
    _classCallCheck(this, CompetitorProductBindDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorProductBindDTOConverterImpl).apply(this, arguments));
  }

  _createClass(CompetitorProductBindDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new CompetitorProductBindDTO_1.CompetitorProductBindDTO(source.id, conversions.toBigNumber(source.ratio), conversions.toBigNumber(source.charger));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        id: source.id,
        ratio: conversions.fromBigNumber(source.ratio),
        charger: conversions.fromBigNumber(source.charger)
      });
      return result;
    }
  }]);

  return CompetitorProductBindDTOConverterImpl;
}(CompetitorProductBindDTOConverter_1.CompetitorProductBindDTOConverter);

exports.CompetitorProductBindDTOConverterImpl = CompetitorProductBindDTOConverterImpl;